import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

function BenefitOrderReopeningStatusTooltip({ benefitOrder, children, placement }) {
  const { reopeningRequestDate, reopeningApprovalDate, reopeningDenialJustification } = benefitOrder;

  const formattedRequestDate = reopeningRequestDate ? reopeningRequestDate.format('DD/MM/YYYY') : '---';
  const formattedApprovalDate = reopeningApprovalDate ? reopeningApprovalDate.format('DD/MM/YYYY') : '---';
  const minWidth = reopeningApprovalDate ? '350px' : '280px';

  return (
    <Tooltip
      title={
        <>
          <span>
            Solicitação (Resposta): {formattedRequestDate} ({formattedApprovalDate})
          </span>
          {reopeningDenialJustification && <br />}
          {reopeningDenialJustification && <span>Motivo: {reopeningDenialJustification}</span>}
        </>
      }
      placement={placement}
      overlayStyle={{ minWidth }}
    >
      {children}
    </Tooltip>
  );
}

BenefitOrderReopeningStatusTooltip.propTypes = {
  benefitOrder: PropTypes.shape,
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
};

BenefitOrderReopeningStatusTooltip.defaultProps = {
  benefitOrder: {},
  placement: 'left',
};

export default BenefitOrderReopeningStatusTooltip;
